import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { httpClient } from 'services/api/httpClient';
import { parseApiError } from 'utils/errorParser';
import { API_ENDPOINTS } from 'constants/apiEndpoints';

const TAB_ENDPOINT = {
  stage1:     API_ENDPOINTS.SEARCH.STAGE1,
  stage2:     API_ENDPOINTS.SEARCH.STAGE2,
  briefing:   API_ENDPOINTS.SEARCH.BRIEFING,
  storage1:   API_ENDPOINTS.SEARCH.STORAGE1,
  storage2:   API_ENDPOINTS.SEARCH.STORAGE2,
  noStorage:  API_ENDPOINTS.SEARCH.NO_STORAGE,
  ocrStorage: API_ENDPOINTS.SEARCH.OCR_STORAGE,
};

export const fetchSearch = createAsyncThunk(
  'search/fetch',
  async ({ tab, ...params }, { rejectWithValue }) => {
    try {
      const endpoint = TAB_ENDPOINT[tab];
      const data = await httpClient.get(endpoint, { params });
      return {
        items:      Array.isArray(data) ? data : (data.items ?? []),
        total:      data.total ?? 0,
        page:       data.page ?? 1,
        pageSize:   data.page_size ?? 10,
        totalPages: data.total_pages ?? 0,
      };
    } catch (error) {
      return rejectWithValue(parseApiError(error));
    }
  }
);

const searchSlice = createSlice({
  name: 'search',
  initialState: {
    items: [],
    meta: { total: 0, page: 1, pageSize: 10, totalPages: 0 },
    status: 'idle',
    error: null,
  },
  reducers: {
    clearSearch(state) {
      state.items = [];
      state.meta = { total: 0, page: 1, pageSize: 10, totalPages: 0 };
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSearch.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchSearch.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload.items;
        state.meta = {
          total:      action.payload.total,
          page:       action.payload.page,
          pageSize:   action.payload.pageSize,
          totalPages: action.payload.totalPages,
        };
      })
      .addCase(fetchSearch.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload?.message ?? 'Search failed';
      });
  },
});

export const { clearSearch } = searchSlice.actions;
export default searchSlice.reducer;
